export default "__VITE_ASSET__iwqF2UdQ__"